import { useState, useEffect } from "react"
import { useGetAllUsersMutation, useDeleteUserMutation } from "./userApiSlice"
import { useDispatch, useSelector } from 'react-redux'
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import SearchableDropdown from "../../components/SearchableDropdown"
import { message, Popconfirm } from 'antd'
import { selectCurrentId } from "../auth/authSlice"

const DeleteUser = () => {
    const id = useSelector(selectCurrentId)

    const [selectedUser, setSelectedUser] = useState(null)
    const [users, setUsers] = useState([])
    const [searchValue, setSearchValue] = useState("")
    const [errorMessage, setErrorMessage] = useState(null)

    const [messageApi, contextHolder] = message.useMessage()
    const dispatch = useDispatch()

    const [ getAllUsers,  {isLoading: isGetAllUsersLoading}] = useGetAllUsersMutation()
    const [ deleteUser,  {isLoading: isDeleteUserLoading}] = useDeleteUserMutation()

    const alertMessage = (message) => {
        messageApi.success(message);
    }

    useEffect(() => {
        if(isDeleteUserLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isDeleteUserLoading])

    useEffect(() => {
        async function handleGetAllUsers() {
          const response = await getAllUsers()
          setUsers(response.data)
        }
        handleGetAllUsers()
    }, [])

    const getUsersOption = () => {
        return users?.filter(user => user.id !== id).map(user => ({id: user.id, name: user.username}))
    }

    const onChangeSearch = (value, id) => {
        if(id) {
            setSelectedUser(id)
        }
        setSearchValue(value)
    }

    const getUser = (id) => {
        return users?.filter(user => user.id === id)[0]
    }

    const handleDeleteUser = async () => {
        setErrorMessage("")

        await deleteUser(selectedUser)

        alertMessage("User Deleted.")
        setUsers((prev) => prev.filter(user => user.id !== selectedUser))

        setSearchValue(null)
        setSelectedUser(null)
    }

    return (
        <div className="manage-user-container">
            {contextHolder}
            <div className='top-header'>
                <header>Delete User</header>
            </div>
            {errorMessage && 
                <div className="errorMessage">
                    <p>{errorMessage}</p>
                </div>
            }
            <div className="delete-body">
                <div className="search-container">
                    <SearchableDropdown
                        options={getUsersOption()}
                        label="name"
                        id="id"
                        placeholderVal={"Select user..."}
                        selectedVal={searchValue}
                        handleChange={(val, id) => onChangeSearch(val, id)}
                    />
                </div>
                {selectedUser && 
                    <>
                        <div className="delete-user-details-header"><h3>User Details</h3></div>
                        <div className="delete-user-details">
                            <div><p><strong>Username:</strong> {getUser(selectedUser)?.username}</p></div>
                            <div><p><strong>First Name:</strong> {getUser(selectedUser)?.firstName}</p></div>
                            <div><p><strong>Last Name:</strong> {getUser(selectedUser)?.lastName}</p></div>
                            <div><p><strong>Role:</strong> {getUser(selectedUser)?.role}</p></div>
                        </div>
                        <Popconfirm
                            title="Delete"
                            description={`Are you sure you want to delete this user?`}
                            onConfirm={() => handleDeleteUser(document.fileName)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <div className="form-group">
                                <button className="crm-button">Delete</button>
                            </div>
                        </Popconfirm>
                    </>
                }
            </div>
        </div>
    )
}

export default DeleteUser